import React from 'react'
import { HONEYPOT_FIELD } from '../../../utils/formEndpoint'

/**
 * Hidden anti-spam field. Real users never see or fill it; bots that
 * auto-complete every input do, and the mailer drops those submissions.
 */
const Honeypot: React.FC<{ value: string; onChange: (value: string) => void }> = ({ value, onChange }) => (
  <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
    <label htmlFor={HONEYPOT_FIELD}>Website</label>
    <input
      type="text"
      id={HONEYPOT_FIELD}
      name={HONEYPOT_FIELD}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      tabIndex={-1}
      autoComplete="off"
    />
  </div>
)

export default Honeypot
